import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trophy-bar',
  templateUrl: './trophy-bar.component.html',
  styleUrls: ['./trophy-bar.component.scss']
})
export class TrophyBarComponent implements OnInit {
show = true;
  constructor() { }

  ngOnInit() {
  }

  close() {
    this.show = !this.show;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/trophy-bar/trophy-bar.component.ts